import React , { useState, useRef, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';  
import {svgIcon, tagType} from "./utility";
import app from './app';
import {NavForm,SwiperHeader, PaddingComponent, BackgroundWidget, ColorWidget2, ColorWidget, getRootValue, Nouislider, GridWidget, linkPopup} from './helpers'

export const TabComponent = (props) => {
    const { properties, rootData, data, edit, langSettings, index, layoutUpdate, commonUpdate, rootUpdate, updateBackground2, update, isFamilyFn, fontSearchChange, setSearchFont, searchFont, textUpdate, gridUpdate, manageUpdate } = props;
    const widgetType = rootData[index].widgetType;
    const [activeTab, setActiveTab] = useState('regular');  
    const handleTabClick = (tabType) => {
        setActiveTab(tabType);
    };
    const linkPopupEvent = () => { 
      let link = data.properties.link
      linkPopup(link,'', function (url) {
        data.properties.link = url;
        if(url.indexOf("javascript:opendeeplinkpage") !== -1) {
          data.properties.target = false;
        }
        commonUpdate("link", url)
      },null, data) 
    }

    
    let defaultTab = null;
    if(properties[0].list.length > 0){
      defaultTab = properties[0].list[0].type; 
    }

    const [openId, setOpenId] = useState(defaultTab);  
    const toggleAccordion = (id) => {
      setOpenId(openId === id ? null : id);
    };
     

    const applyAll = function(event){
      manageUpdate("apply", event.currentTarget.getAttribute("data-id"))
      
    }
    const forceUpdate = function(e){
      manageUpdate("forceUpdate", e.currentTarget.id, e.currentTarget.value);
    }

    useEffect(() => {
      if(data.viewType === "image") {
        if(data.properties.alt) {
          document.querySelector("#alt").value = data.properties.alt;
        }
        else {
          document.querySelector("#alt").value = "";
        }
      }
    }, [data]);
     
    const renderContent = (tabType) => {
           return properties
            .filter(prop => prop.tabType === tabType)
            .map((prop, idx) => (
              <div key={idx} className={`tabComponent-body ${activeTab === tabType ? 'active' : ''}`}>  
                    {prop.list.map((v, i) => {  
                          if(v.type === "linkType" && !data.properties.staticLink && !data.properties.iconStatic){
                            let linkWidget = <div class={`pannel-${widgetType} pannel-${app.getDevice()?'desktop':'mobile'}`}>
                                  <div className="align-items-center">
                                    {/* <label>{langSettings.link}</label> */}
                                    <div className="text-right ms-auto position-relative border-bottom d-flex">
                                      <input type="text" className="form-control border-0 px-0" value={data.properties.link ? data.properties.link : ''} placeholder="https://example.com/" id="link" data-index={index} name="link" onChange={(event)=>commonUpdate(event.target.name, event.target.value)} onClick={linkPopupEvent} readOnly/>
                                      <button className="target-setting input-group-text border-0 bg-white ic_ai_icon_game_setting_8" onClick={linkPopupEvent}></button>
                                    </div>
                                  </div>
                              
                                  <div className="d-flex flex-1 align-items-center pt-2 pb-1">
                                    <div className="form-check">
                                      <input className="form-check-input" type="checkbox" checked={data.properties.target} placeholder=" " id="target" data-type="target" data-index={index} onChange={(e)=>commonUpdate("target", !data.properties.target)}/>
                                      <label className="form-check-label m-0" for="target">
                                        {langSettings.open_in_new_window}
                                      </label>
                                    </div>  
                                  </div>
                                </div>
                            if(data.properties.staticLink || data.properties.iconStatic){
                              linkWidget = ""
                            } 
                            return (
                              <div data-type={v.type} class={`accordion-item pannel-${widgetType} pannel-${app.getDevice()?'desktop':'mobile'} ${openId === v.type ? 'show' : ''}`}>
                                <div class="accordion-item-header" data-target={v.type} onClick={() => toggleAccordion(v.type)}><span className='arrow-right'></span>{langSettings.hyperlink}</div>
                                <div class="accordion-item-body" id={v.type}> 
                                 {linkWidget} 
                          
                                {data.properties.autoLoadLink !== undefined?
                                  <div className="d-flex flex-1 builder-widget align-items-center pt-0 pb-0 autoLoadLink">
                                    <div className="form-check">
                                      <input className="form-check-input" type="checkbox" checked={data.properties.autoLoadLink} placeholder=" " id="autoLoadLink" data-type="autoLoadLink" data-index={index} onChange={(e)=>commonUpdate("autoLoadLink", !data.properties.autoLoadLink)}/>
                                      <label className="form-check-label m-0" for="autoLoadLink">
                                        {langSettings.autoLoadLink}
                                      </label>
                                    </div>  
                                  </div>
                                :null}

                                {data.properties.showHeader !== undefined && !app.getDevice() && !data.properties.target && data.properties.autoLoadLink?
                                  <>
                                  <div className="d-flex flex-1 builder-widget align-items-center pt-1 pb-2">
                                    <div className="form-check">
                                      <input className="form-check-input" type="checkbox" checked={data.properties.showHeader} placeholder=" " id="showHeader" data-type="showHeader" data-index={index} onChange={(e)=>commonUpdate("showHeader", !data.properties.showHeader)}/>
                                      <label className="form-check-label m-0" for="showHeader">
                                        {langSettings.showHeader}
                                      </label>
                                    </div>  
                                  </div>
                                <div>{
                                 
                                  [
                                    {"key":"iconColor", "lang":"icon_color"},
                                    {"key":"iconBackground", "lang":"icon_background"},
                                    {"key":"iconActiveColor", "lang":"icon_active_color"},
                                    {"key":"iconActiveBackground", "lang":"icon_active_background"},
                                    {"key":"headerBgColor", "lang":"icon_active_background"}
                                    
                                   
                                  ].map(function(x, i){
                                    if(x.key === "headerBgColor") {
                                      return <BackgroundWidget type={langSettings.background} data={data} backgroundType={data.properties.headerBgType} id={x.key} index={i} value={data.properties.headerBgColor} callback={updateBackground2}/>
                                    }
                                    
                                    return  <ColorWidget type={langSettings[x.lang]} id={x.key} index={i} value={data.properties[x.key]} callback={function(a){
                                      commonUpdate(x.key, a);
                                    }}/>  
                                  })
                                  
                                  }</div>
                                  </>
                                :null} 
                              </div>
                              </div>
                            );

                          }
                          else if(v.type === "mediaType"){
                            return (
                              <div data-type={v.type} class={`accordion-item pannel-${widgetType} pannel-${app.getDevice()?'desktop':'mobile'} ${openId === v.type ? 'show' : ''}`}>
                                <div class="accordion-item-header" data-target={v.type} onClick={() => toggleAccordion(v.type)}><span className='arrow-right'></span>{langSettings.media_settings}</div>
                                <div class="accordion-item-body" id={v.type}> 
                                {
                                  v.item.map(function(x,y){   
                                    if(x === "src") { 
                                      let size = "";
                                      if(data.properties){ 
                                        if (data.properties.ratio || data.properties.ratioWeb) {
                                          if (data.properties.ratio !== "" || data.properties.ratioWeb !== "") {
                                            size = <div className="col m-0">
                                              <label>{langSettings.size}</label>
                                              <div className="text-right ms-auto">
                                                <select className="form-select" value={app.getDevice()?data.properties.scaleTypeWeb:data.properties.scaleType} id="size" data-index={index} data-type={app.getDevice()?"scaleTypeWeb":"scaleType"} onChange={(e)=>commonUpdate(e.currentTarget.getAttribute('data-type'),e.currentTarget.value)}>
                                                  { 
                                                    [{ key: "CENTER_CROP", text: app.getLang("cover") }, { key: "CENTER_INSIDE", text: app.getLang("contain")}, { key: "FIT_XY", text: app.getLang("scale")}].map(function (v) {
                                                      return <option value={v.key} key={v.key}>{v.text}</option>
                                                    })
                                                  }
                                                </select>
                                              </div>
                                            </div>
                                          }
                                        } 
                                      } 
                                      return <div><div className="d-flex align-items-center mb-3">
                                      <input type="button" id="icon" value={data.properties.src} style={{ display: "none" }} />
                                      <button className={`btn btn-outline-secondary btn-image-select img-view`} style={{backgroundImage: `url('${data.properties.src}')` }} onClick={function(){
                                        app.imagePopup(data.properties.src, function(key, value){
                                          commonUpdate(key, value) 
                                        })
                                      }}></button>
                                    </div>  
                                    <div className="row">
                                    <div className="col m-0">
                                      <label>{langSettings.ratio}</label>
                                      <div className="text-right ms-auto">
                                        <select className="form-select" value={app.getDevice()?data.properties.ratioWeb:data.properties.ratio} id="ratio" data-index={index} data-type={app.getDevice()?"ratioWeb":"ratio"} onChange={(e)=>commonUpdate(e.currentTarget.getAttribute('data-type'),e.currentTarget.value)}>
                                          {/* <option value={""}>{langSettings.default}</option> */}
                                          {
                                            data.properties.cornerType === "circular"?
                                            ["1x1"].map(function (v) {
                                              return <option>{v}</option>
                                            })
                                            :
                                            ["1x1", "2x1", "3x1", "4x1", "3x2", "4x3", "1x2", "1x3", "1x4", "2x3", "3x4"].map(function (v) {
                                              return <option>{v}</option>
                                            })
                                          }
                                        </select>
                                      </div>
                                    </div>
                                    {size}
                                  </div>
                                  <div className="row">
                                    <div className="col mt-3">
                                      <label>{app.getLang("altText")}</label>
                                      <div className="text-right ms-auto" style={{border:"solid 1px #95C9F5", borderRadius:"4px"}}>
                                      <input type="text" className="form-control border-0 p-2" defaultValue={data.properties.alt} placeholder={app.getLang("altText")} id="alt" data-index={index} name="alt" onBlur={forceUpdate} />
                                      </div>
                                    </div>
                                  </div>
                                  </div>
                                    }
                                    else if(x === "iconCode"){
                                      let actionType = <button className={`btn ${data.properties.iconCode}`} value={data.properties.iconCode} onClick={function(){
                                        app.imagePopup(data.properties.iconCode, function(type, src){
                                          commonUpdate(type, src);
                                        }, 'iconCode')
                                      }}></button>;
                                
                                     if(data.properties.iconCode.indexOf('https://') !== -1){ 
                                        actionType = <button className={`btn btn-outline-secondary btn-image-select img-view`} style={{background: `url(${data.properties.iconCode}) no-repeat 0 0 / cover`}} onClick={function(){
                                          app.imagePopup(data.properties.iconCode, function(type, src){
                                            commonUpdate(type, src);
                                          }, 'iconCode')
                                        }}></button>;
                                    }
                                      return <div className="upload-assest">
                                        <label className="label">{langSettings.icon}</label>
                                        {actionType}
                                      </div>
                                    }
                                    else if(x === "videoSrc"){ 
                                        return <div><div className="col-12 mb-3">
                                          <input type="button" id="icon" value={data.properties.thumb} style={{ display: "none" }} />
                                          <button className={`btn btn-outline-secondary btn-image-select img-view`} style={{backgroundImage: `url('${data.properties.thumb}')` }} onClick={function(){
                                            app.videoPopup(data.properties, function(key, value){
                                              commonUpdate(key, value) 
                                            })
                                          }}> 
                                          </button>
                                      </div>  
                                      <div className="col-12">
                                          <label>{langSettings.ratio}</label>
                                          <div className="text-right ms-auto">
                                            <select className="form-select" value={app.getDevice()?data.properties.ratioWeb:data.properties.ratio} id="ratio" data-index={index} data-type={app.getDevice()?"ratioWeb":"ratio"} onChange={function(e){ 
                                                 if(app.getDevice()){
                                                  commonUpdate('ratioWeb', e.target.value) 
                                                }else{
                                                  commonUpdate('ratio', e.target.value) 
                                                } 
                                              }}>
                                              {
                                                ["1x1", "2x1", "3x1", "3x2", "4x3", "16x9", "1x2", "2x3", "3x4", "9x16"].map(function (v) {
                                                  return <option>{v}</option>
                                                })
                                              }
                                            </select>
                                          </div> 
                                      </div> 
                                      </div>  
                                    }

                                  }) 
                                }
                              </div>
                              </div>
                            );
                           
                          }
                          else if(v.type === "colorType"){
                            let item =  v.item.map(function(x,y){ 
                              let value = data["properties"][x]; 
                              console.log("value 1", value)
                              if(data.viewType === "view" || data.viewType === "gridItem") {
                                value = app.getItemValue(data, x);
                                console.log("value 2", value)
                              }

                              if(x === "textColor") { 
                                if(value === undefined){
                                  value = getRootValue(data, x)
                                  console.log("value 3", value)  
                                }
                                 return <ColorWidget type={langSettings.text_color} id={x} value={value} index={i} callback={function(a){
                                  rootUpdate("textColor", a);
                                }}/>   
                              } 
                              if(x === "tagColor") { 
                                if(value === undefined){
                                  value = getRootValue(data, x)
                                }
                                 return <ColorWidget type={"Tag Color"} id={x} value={value} index={i} callback={function(a){
                                  rootUpdate("tagColor", a);
                                }}/>   
                              } 
                              if(x === "trackColor") { 
                                if(value === undefined){
                                  value = getRootValue(data, x)
                                }
                                 return <ColorWidget type={"Bar Track Color"} id={x} value={value} index={i} callback={function(a){
                                  rootUpdate("trackColor", a);
                                }}/>   
                              } 
                              if(x === "fillColor") { 
                                if(value === undefined){
                                  value = getRootValue(data, x)
                                }
                                 return <ColorWidget type={"Bar Fill Color"} id={x} value={value} index={i} callback={function(a){
                                  rootUpdate("fillColor", a);
                                }}/>   
                              }
                              if(x === "submenuTextColor") { 
                                if(value === undefined){
                                  value = getRootValue(data, x)
                                }
                                 return <ColorWidget type={"Submenu Text Color"} id={x} value={value} index={i} callback={function(a){
                                  rootUpdate("submenuTextColor", a);
                                }}/>   
                              } 
                              
                              if(x === "navBackground" && value) {
                                return <BackgroundWidget type={langSettings.menuBackground} data={data} id={x} backgroundType={data.properties.navBackgroundType} index="99" value={data.properties["navBackground"]} callback={updateBackground2}/>
                              }
                              else if(x === "submenuBackground") {
                                return <BackgroundWidget type={"Submenu Background"} data={data} id={x} backgroundType={data.properties.submenuBackgroundType} index="99" value={data.properties["submenuBackground"]} callback={updateBackground2}/>
                              }
                              else if(x === "tagBackground" && value) {
                                return <BackgroundWidget type={"Tag Background"} data={data} id={x} backgroundType={data.properties.tagBackgroundType} index="99" value={data.properties["tagBackground"]} callback={updateBackground2}/>
                              }
                              else if(x === "background" && value) { 
                                if(data.widgetType === "headerAi"){
                                  if(app.getDevice() && data.properties["backgroundWeb"] !== undefined){
                                    return <BackgroundWidget widgetType={data.widgetType} type={langSettings.background} data={data}  id="backgroundWeb" index={i} value={data.properties["backgroundWeb"]} backgroundType={data.properties.backgroundWebType} callback={updateBackground2}/>
                                  }
                                  else{
                                    return <BackgroundWidget widgetType={data.widgetType} type={langSettings.background} data={data} id="background" index={i} value={value} backgroundType={data.properties.backgroundType} callback={updateBackground2}/>
                                  }
                                }
                                else{
                                  return <BackgroundWidget widgetType={data.widgetType} type={langSettings.background} data={data} id="background" index={i} value={value} backgroundType={data.properties.backgroundType} callback={updateBackground2}/>
                                } 
                              } 
                              else if(x === "iconColor") {
                                if(app.getDevice() && data.properties["iconColorWeb"] !== undefined){
                                  return <ColorWidget type={langSettings.icon_color} id="iconColorWeb" value={data.properties["iconColorWeb"]} index={i} callback={function(a){
                                    rootUpdate("iconColorWeb", a);
                                  }}/>
                                }else{
                                  return <ColorWidget type={langSettings.icon_color} id="iconColor" value={value} index={i} callback={function(a){
                                    rootUpdate("iconColor", a);
                                  }}/>
                                } 
                              } 
                              else if(x === "iconBackground") {
                                if(app.getDevice() && data.properties["iconBackgroundWeb"] !== undefined){
                                  return <ColorWidget type={langSettings.icon_background} id="iconBackgroundWeb" index={i} value={data.properties["iconBackgroundWeb"]} callback={function(a){
                                    rootUpdate("iconBackgroundWeb", a);
                                  }}/>
                                }else{
                                  return <ColorWidget type={langSettings.icon_background} id="iconBackground" index={i} value={value} callback={function(a){
                                    rootUpdate("iconBackground", a);
                                  }}/>
                                } 
                              }

                              else if(x === "iconTextColor") {
                                  return <ColorWidget type={langSettings.badgeColor} id={x} value={value} callback={function(a){commonUpdate(x, a)}}/>
                              } 
                              else if(x === "iconTextBgColor") {
                                return <ColorWidget type={langSettings.badgeBackground} id={x} value={value} callback={function(a){commonUpdate(x, a)}}/>
                              } 

                              else if(x === "defaultHeaderBgColor" && value) {
                                if(data.widgetType === "headerAi" && !app.getDevice()){
                                  //l_gradient pattern image custom
                                  //if(data.properties.backgroundType !== "color") {
                                    //if(data.settings["isImageInnerPage"] && data.properties["defaultHeaderBgColor"]){
                                      return <ColorWidget type={langSettings.defaultBG} id={x} index={i} value={data.properties["defaultHeaderBgColor"]} callback={function(a){
                                        commonUpdate(x, a);
                                      }}/>  
                                    //} 
                                  //}
                                } 
                              } 
                              else if(x === "overlayColor") {  
                                if(app.getDevice() && data.properties["overlayColorWeb"] !== undefined){
                                  return <ColorWidget type={langSettings.overlay_color} id="overlayColorWeb" index={i} value={data.properties["overlayColorWeb"]} callback={function(a){
                                    commonUpdate("overlayColorWeb", a);
                                  }}/> 
                                }else{
                                  return <ColorWidget type={langSettings.overlay_color} id="overlayColor" index={i} value={value} callback={function(a){
                                    commonUpdate("overlayColor", a);
                                  }}/>  
                                }    
                              }
                              
                              
                              //++++Hover Propertis++++//
                              else if(x === "textColorHover") { 
                                return <ColorWidget type={langSettings.text_color} id={x} value={value} index={i} callback={function(a){
                                  rootUpdate("textColorHover", a);
                                }}/>   
                              } 
                              else if(x === "backgroundHover") {
                                return <BackgroundWidget type={langSettings.background} data={data} backgroundType={data.properties.backgroundHoverType} id={x} index={i} value={value} callback={updateBackground2}/>
                              }
                              else if(x === "submenuTextColorHover") { 
                                return <ColorWidget type={"Submenu Text Color"} id={x} value={value} index={i} callback={function(a){
                                  rootUpdate("submenuTextColorHover", a);
                                }}/>   
                              } 
                              else if(x === "submenuBackgroundHover") {
                                return <BackgroundWidget type={"Submenu Background"} data={data} backgroundType={data.properties.submenuBackgroundHoverType} id={x} index={i} value={value} callback={updateBackground2}/>
                              }
                             

                              //++++Clicked Propertis++++//

                              
                              else if(x === "textColorClick") { 
                                return <ColorWidget type={langSettings.text_color} id={x} value={value} index={i} callback={function(a){
                                  rootUpdate("textColorClick", a);
                                }}/>   
                              } 
                              else if(x === "backgroundClick") {
                                return <BackgroundWidget type={langSettings.background} data={data} backgroundType={data.properties.backgroundClickType} id={x} index={i} value={value} callback={updateBackground2}/>
                              }
                              else if(x === "submenuTextColorClick") { 
                                return <ColorWidget type={"Submenu Text Color"} id={x} value={value} index={i} callback={function(a){
                                  rootUpdate("submenuTextColorClick", a);
                                }}/>   
                              } 
                              else if(x === "submenuBackgroundClick") {
                                return <BackgroundWidget type={"Submenu Background"} data={data} backgroundType={data.properties.submenuBackgroundClickType} id={x} index={i} value={value} callback={updateBackground2}/>
                              }


                              return null;
                            })

                            item = item.filter(item => item !== null); 

                            if(item.length > 0){  
                                return (
                                  <div data-type={v.type} class={`accordion-item pannel-${widgetType} pannel-${app.getDevice()?'desktop':'mobile'} ${openId === v.type ? 'show' : ''}`}>
                                    <div class="accordion-item-header" data-target={v.type} onClick={() => toggleAccordion(v.type)}><span className='arrow-right'></span>{langSettings.fill_color_opacity}</div>
                                    <div class="accordion-item-body" id={v.type}> 
                                     {item}
                                  </div>
                                  </div>
                                ); 
                            }
                          }
                         
                        
                          else if(v.type === "settingsType" && widgetType === "faq_one" && data.viewType === "grid"){
                            let haveItems = false;
                            const settingsItems = v.item.map(function(x,y){ 
                              if(data["properties"][x] !== undefined) {
                                if(x === "collapse") {
                                  if(edit.grid === "0") {
                                    haveItems = true;
                                    return <div className="form-check hide-list form-switch" data-id={v}>
                                    <label className="form-check-label m-0">Collapse</label>
                                    <input type="checkbox" className="form-check-input ms-auto mt-0" data-id={v} checked={data.properties.collapse} onChange={function(e){
                                      manageUpdate("collapse", "collapse", data.properties.collapse?false:true)
                                    }} />
                                    </div>
                                  }
                                }
                                else {
                                  haveItems = true;
                                }
                              }
                              return null;
                            });
                            
                            if(haveItems) {
                              return   <div data-type={v.type} className={`accordion-item pannel-${widgetType} pannel-${app.getDevice()?'desktop':'mobile'} ${openId === v.type ? 'show' : ''}`}>
                              <div class="accordion-item-header" data-target={v.type} onClick={() => toggleAccordion(v.type)}><span className='arrow-right'></span>{langSettings.settings}</div>
                              <div class="accordion-item-body" id={v.type}>
                                {settingsItems}
                              </div>
                              </div>
                            }
                            
                          }
                          else if(v.type === "borderCornersType"){
                            return (
                              <div data-type={v.type} class={`accordion-item pannel-${widgetType} pannel-${app.getDevice()?'desktop':'mobile'} ${openId === v.type ? 'show' : ''}`}>
                                <div class="accordion-item-header" data-target={v.type} onClick={() => toggleAccordion(v.type)}><span className='arrow-right'></span>{langSettings.border_radius}</div>
                                <div class="accordion-item-body" id={v.type}>
                                  {
                                    v.item.map(function(x,y){ 
                                      let value = data["properties"][x]; 
                                      if(data.viewType === "view" || data.viewType === "gridItem") {
                                        value = app.getItemValue(data, x);
                                      } 
                                      
                                      if(x === "borderCorners" && value) {
                                        return <div className={`itemContainer ${x}`}>
                                           <PaddingComponent id={x} callback={commonUpdate} value={data.properties["borderCorners"]}/> 
                                        </div>  
                                      }  
                                      if(x === "cornersWeb" && value) {
                                        return <div className={`itemContainer ${x}`}>
                                          <div className="itemContainer">
                                          <label>{langSettings.cornersType}</label>
                                          <div className="text-right ms-auto">
                                            <select className="form-select" value={data.properties.cornerType} id="borderStyle" data-index={index} data-type="cornerType" onChange={(e)=>commonUpdate("cornerType", e.currentTarget.value)}>
                                              {
                                                [{ key: "rounded", text: app.getLang("rounded")}, { key: "circular", text: app.getLang("circle")}].map(function (v) {
                                                  return <option value={v.key}>{v.text}</option>
                                                })
                                              }
                                            </select>
                                          </div>  
                                        </div> 
                                        {data.properties.cornerType === "rounded"?
                                            <PaddingComponent title={langSettings.corners_radius} id={app.getDevice()?x:"corners"} callback={commonUpdate} value={app.getDevice()?data.properties["cornersWeb"]:data.properties["corners"]}/> 
                                        :null} 
                                    </div>  
                                      }   
                                    }) 
                                  }
                                </div>
                              </div>
                            ); 
                          }  
                  
                          else if (v.type === "fontType") {
                            return (
                              <div data-type={v.type} class={`accordion-item pannel-${widgetType} pannel-${app.getDevice()?'desktop':'mobile'} ${openId === v.type ? 'show' : ''}`}>
                                <div class="accordion-item-header" data-target={v.type} onClick={() => toggleAccordion(v.type)}><span className='arrow-right'></span>{langSettings.text}</div>
                                <div class="accordion-item-body" id={v.type}>
                                {
                                  v.item.map(function(x,y){
                                    let value = data["properties"][x]; 
                                    if(data.viewType === "view" || data.viewType === "gridItem") {
                                      value = app.getItemValue(data, x);
                                    } 
                                    if(x === "textSizeWeb") {  
                                      if(value === undefined){
                                        value = getRootValue(data, x)  
                                      }
                                      else{
                                        if(app.getDevice()){
                                          value = data.properties["textSizeWeb"]
                                        }else{
                                          value = data.properties["textSize"]
                                        }
                                      }

                                      return <div className={`itemContainer ${x}`}>
                                        <label className="d-block fw-bold col-12">{langSettings.size}</label>
                                        <Nouislider range={{ min: 0, max: 100 }} step="1" start={value} connect={"lower"} id={app.getDevice()?x:'textSize'} connectColor="#3899ED" handleColor="#E2F2FF" callback={rootUpdate}/>
                                      </div> 
                                    }
                                    else if(x === "textStyle") {    
                                      if(widgetType !== "headerAi" && (data.viewType === "text" || data.viewType === "textHtml" || data.viewType === "button")){
                                        return <div widgetType={data.widgetType} className={`itemContainer viewType-${data.viewType}`}> 
                                          <div className={`textStyleContainer deskStyle ${data.viewType} `} data-type="bold">  
                                            <button data-type="bold" onClick={window.iframeEditor}>{svgIcon.bold}</button>
                                            <button data-type="italic" onClick={window.iframeEditor}>{svgIcon.italic}</button>
                                            <button data-type="underline" onClick={window.iframeEditor}>{svgIcon.underline}</button>
                                            <button data-type="strikethrough" onClick={window.iframeEditor}>{svgIcon.strike}</button>
                                            <a onClick={window.editorLink} data-type="createlink" className="b-icon disabled">{svgIcon.link}</a>
                                            <a onClick={window.editorLink} data-type="unlink" className="b-icon disabled">{svgIcon.unlink}</a>
                                          </div> 
                                        </div> 
                                      }
                                    }
                                    else if(x === "iconSizeWeb") {
                                      return <div className={`itemContainer ${x}`}>
                                      <label className="d-block fw-bold col-12">{langSettings.size}</label>
                                      <Nouislider range={{ min: 0, max: 50 }} step="1" start={value} connect={"lower"} id={app.getDevice()?x:'iconSize'} connectColor="#3899ED" handleColor="#E2F2FF" callback={function(nextId, nextValue){
                                        rootUpdate(nextId, nextValue.toString());
                                      }}/>
                                    </div>  
                                    }
                                    else if(x === "tagType") {
                                      return  <div className={`itemContainer ${x}`}>
                                         <label>{app.getLang("type")}</label>
                                        <div className="text-right ms-auto"> 
                                        <select className="form-select" value={data.properties[x]} id={"tagType"} name="tagType" onChange={forceUpdate} style={{width: "100%"}}>
                                        <option value={""}>{app.getLang("none")}</option>
                                          {
                                            tagType.map(function(v){
                                              return <option key={v.key} value={v.key}>{app.getLang(v.text)} ({v.key.toUpperCase()})</option>
                                            })
                                          }
                                        </select> 
                                        </div>
                                      </div>
                                    }
                                    else if(x === "fontFamily") {
                                      let fonts = [];
                                      if(localStorage.getItem("fonts")) {
                                        fonts = JSON.parse(localStorage.getItem("fonts"));
                                      }
                          
                                      if(value === undefined){
                                         value = getRootValue(data, v) 
                                      }
                                        
                                      return  <div className={`itemContainer ${x}`}>
                                      <label>{langSettings.font}</label>
                                        <div className="text-right ms-auto"> 
                          
                                          <div className='fontFamilyContainer text-start'> 
                                              <div className='hideDrop' onClick={isFamilyFn}></div>
                                              <div className='selectedFamily' onClick={isFamilyFn}>{value?value:langSettings.default}</div>
                                              <div className='fontDropdown'>
                                                  <div className='font-search'>
                                                    <input id="searchFonts" className='form-control' type='text' placeholder="Search fonts" autoComplete="off" autoCorrect="off" onChange={fontSearchChange}/>
                                                  </div>
                                                  <ul className='fontFamilyList'>  
                                                      {
                                                        fonts.map(function (v) {
                                                          return <li data-value={v} onClick={function(a){ 
                                                            if(document.querySelector(".fontFamilyContainer").classList.contains("on")){
                                                              // console.log(a.target.getAttribute("data-value"))
                                                              document.querySelector(".selectedFamily").innerHTML = a.target.getAttribute("data-value")
                                                              document.querySelector(".fontFamilyContainer").classList.remove("on")
                                                            } 
                                                            rootUpdate("fontFamily", a.target.getAttribute("data-value"))
                                                            if(document.getElementById("searchFonts")){
                                                              setSearchFont('')
                                                              document.getElementById("searchFonts").value = ""
                                                            }
                                                        }} style={{display:v.toLowerCase().includes(searchFont) || searchFont === ""? "block": "none"}}>{v}</li>
                                                        }) 
                                                      }  
                                                  </ul>
                                              </div>
                                          </div>
                                          
                                          
                                        </div>
                                      </div>
                                    } 
                                    else if(x === "textAlignment" ) {
                                      if(widgetType === "headerAi"){
                                        return false
                                      }
                                      else{
                                        return <div className="col-12" id="textAlignment"> 
                                        <label className="d-block fw-bold col-12 mb-2">{langSettings.font_align}</label>
                                            <div className="ms-auto btn-wrapper d-flex">  
                                            {
                                              [
                                                { key: 'start', icon: 'icon-align-left'},
                                                { key: 'center', icon: 'icon-align-center'},
                                                { key: 'end', icon: 'icon-align-right'},
                                                { key: 'justify', icon: 'icon-menu-1'}
                                            ].map(function(v,i){
                                              let active = ''
                                              if(v.key === value){
                                                active = 'active'
                                              }
                                              return <button className={`all-alignment btn-icon ${active}`} id="textAlignment" value={v.key} onClick={function(){
                                                rootUpdate("textAlignment", v.key);
                                                rootUpdate("itemAlignment", v.key);
                                                rootUpdate("iconAlignment", v.key);
                                              }}><i className={v.icon}></i></button>
                                              })
                                            }
                                            </div>
                                          </div>
                                      }
                                     
                                    }
                                    else if(x === "iconAlignment" && data.properties["iconAlignment"]) {
                                      return  <div className="col-12" id="iconAlignment"> 
                                      <label className="d-block fw-bold col-12 mb-2">{langSettings.icon_align}</label>
                                        <div className="ms-auto btn-wrapper">  
                                        {
                                          [
                                            { key: 'start', icon: 'icon-align-left'},
                                            { key: 'center', icon: 'icon-align-center'},
                                            { key: 'end', icon: 'icon-align-right'},
                                            { key: 'justify', icon: 'icon-menu-1'}
                                        ].map(function(v,i){
                                          let active = ''
                                          if(v.key === value){
                                            active = 'active'
                                          }
                                          return <button className={`btn-icon ${active}`} id="iconAlignment" value={v.key} onClick={function(){
                                            rootUpdate("iconAlignment", v.key); 
                                          }}><i className={v.icon}></i></button>
                                          })
                                        }
                                        </div>
                                      </div>
                                    }
                                  }) 
                                }
                              </div>
                              </div>
                            );
                          } 
                         
                          else if(v.type === "borderType"){
                            let notfound = false;
                            return (
                              <div data-type={v.type} class={`accordion-item pannel-${widgetType} pannel-${app.getDevice()?'desktop':'mobile'} ${openId === v.type ? 'show' : ''}`}>
                                <div class="accordion-item-header" data-target={v.type} onClick={() => toggleAccordion(v.type)}><span className='arrow-right'></span>{langSettings.border}</div>
                                <div class="accordion-item-body" id={v.type}>
                                {
                                  v.item.map(function(x,y){  
                                    if(x === "borderColor" || x === "menuBorderColor" || x === "borderColorHover" || x === "borderColorClick") {   
                                      let title = langSettings.border_color;
                                      // console.log("data.viewType", data.viewType)
                                      if(data.viewType === "navigation" || data.viewType === "footerNavigation"){
                                        if(x === "borderColor" || x === "borderColorHover" || x === "borderColorClick"){
                                          title = langSettings.itemBorderColor;
                                        }else if(x === "menuBorderColor"){
                                          title = langSettings.menuBorderColor;
                                        }
                                      }  
                                      return <ColorWidget type={title} id={x} index={i} value={data.properties[x]} callback={function(a){
                                          commonUpdate(x, a)
                                        }}/> 
                                    } 
                                    else if(x === "borderType" || x === "menuBorderType") { 
                                      let title = langSettings.border_style;
                                      if(data.viewType === "navigation" || data.viewType === "footerNavigation"){
                                        if(x === "borderType"){
                                          title = langSettings.itemBorderStyle;
                                        }else if(x === "menuBorderType"){
                                          title = langSettings.menuBorderStyle;
                                        }
                                      }  
                                      return  <div className='itemContainer d-grid'>
                                      <label className="label">{title}</label>
                                      <div className='d-flex'>
                                         <select className="form-select" defaultValue={data.properties[x]} onChange={(e)=>commonUpdate(x, e.currentTarget.value)} style={{width: "100%"}}>
                                          <option value="line">{app.getLang("line")}</option>
                                          <option value="dash">{app.getLang("dash")}</option>
                                        </select> 
                                      </div>   
                                    </div>  
                                    } 
                                    else if(x === "borderWidget" || x === "menuBorderWidget" && app.getDevice()) { 
                                      if(data.properties[x] !== undefined){
                                        let title = langSettings.border_size; 
                                        if(data.viewType === "navigation" || data.viewType === "footerNavigation"){
                                          if(x === "borderWidget"){
                                            title = langSettings.itemBorderSize;
                                          }else if(x === "menuBorderWidget"){
                                            title = langSettings.menuBorderSize;
                                          }
                                        }   
                                        return <PaddingComponent className="itemContainer" id={x} title={title} callback={commonUpdate} value={data.properties[x]}/> 
                                      }
                                    } 
                                    else if(x === "borderSize"){
                                      if(data.properties["borderSize"] !== undefined){
                                        return <div className='itemContainer d-grid'>
                                         <label className="label">{langSettings.border_size}</label>
                                         <div className='d-flex'> 
                                          <Nouislider range={{ min: 0, max: 10 }} step="1" start={data.properties["borderSize"]} connect={"lower"} id={x} connectColor="#3899ED" handleColor="#E2F2FF" callback={commonUpdate}/>
                                           {/* <input type="number" inputMode="numeric" pattern="[0-9]*" className="form-control" min="0" max="10" value={data.properties["borderSize"]} onChange={(e)=>sizeUpdate("borderSize", e.currentTarget.value)}  onBlur={(e)=>sizeUpdateEmptyInput("borderSize", e.currentTarget.value)} style={{marginRight: "20px", width: "60px"}}/>  */}
                                         </div>   
                                       </div> 
                                      }
                                    }else{
                                      notfound = true
                                    }
                                  }) 
                                }
                              </div>
                              </div>
                            );
                   
                          } 
                  
                          else if(v.type === "spacingType"){
                             
                            let item = v.item.map(function(x,y){ 
                              let value = data["properties"][x]; 
                              if(data.viewType === "view" || data.viewType === "gridItem") {
                                value = app.getItemValue(data, x);
                              } 
                              if(x === "navPaddingWeb" && value) {
                                return <div className={`itemContainer ${x}`}>
                                   <PaddingComponent title={langSettings.menuPadding} id={app.getDevice()?x:"navPadding"} callback={commonUpdate} value={app.getDevice()?data.properties["navPaddingWeb"]:data.properties["navPadding"]}/> 
                                </div>  
                              }  
                              else if(x === "paddingWeb" && value) { 
                                if(!app.getDevice() && widgetType === "headerAi"){
                                  return null
                                }
                                let title = langSettings.padding;  
                                if(data.viewType === "navigation" || data.viewType === "footerNavigation"){
                                  title = langSettings.itemPadding;
                                }  
                                return <div className={`itemContainer ${x}`}>
                                   <PaddingComponent title={title} id={app.getDevice()?x:"padding"} callback={commonUpdate} value={app.getDevice()?data.properties["paddingWeb"]:data.properties["padding"]}/> 
                                </div>   
                              } 
                              else if(x === "marginWeb" && data.properties["marginWeb"]) {  
                                let title = langSettings.btn_margin;
                                if(data.viewType === "socialLinks"){
                                  title = langSettings.icon_margin;
                                }
                                if(data.viewType === "gridItem"){
                                  title = "Margin";
                                }
                                return <div className={`itemContainer ${x}`}>
                                   <PaddingComponent title={title} id={app.getDevice()?x:"margin"} callback={commonUpdate} value={app.getDevice()?data.properties["marginWeb"]:data.properties["margin"]}/> 
                                </div>   
                              } 
                              else if(x === "isFluid" && app.getDevice()) {     
                                  return <div className='itemContainer'>
                                    <label className="mb-2">{langSettings.background_width}</label>  
                                    <div className="btn-group text-center btn-container-wrap" > 
                                    { 
                                      [{key:"isFluid", value:"container", text:app.getLang("inset")},{key:"isFluid", value:"container-fluid", text:app.getLang("fullBleed")}].map(function(v){
                                        return <button className={`btn ${data.properties["isFluid"] == v.value ? 'active' : ''}`} onClick={() => commonUpdate(v.key, v.value)}>{v.text}</button>
                                      })
                                    } 
                                    </div>
                                  </div> 
                              }
                              else if(x === "logoDimension" && app.getDevice() && widgetType === "headerAi"){ 
                                  return <div className='itemContainer d-grid'>
                                      <label className="label">{langSettings.logoDimension}</label>
                                      <Nouislider range={{ min: 0, max: 120 }} step="1" start={value} connect={"lower"} id={x} connectColor="#3899ED" handleColor="#E2F2FF" callback={commonUpdate}/>
                                  </div>  
                              }
                              else if(x === "linkSpacing" && app.getDevice() && widgetType === "headerAi"){   
                                  return <div className='itemContainer d-grid' data-value={value}>
                                      <label className="label">{langSettings.linkSpacing}</label>
                                      <Nouislider range={{ min: 0, max: 5 }} step="0.1" start={value} connect={"lower"} id={x} connectColor="#3899ED" handleColor="#E2F2FF" callback={commonUpdate}/>
                                  </div>  
                              }
                              else if(x === "elementSpacing" && app.getDevice() && widgetType === "headerAi"){ 
                                  return <div className='itemContainer d-grid'>
                                      <label className="label">{langSettings.elementSpacing}</label>
                                      <Nouislider range={{ min: 0, max: 5 }} step="0.1" start={value} connect={"lower"} id={x} connectColor="#3899ED" handleColor="#E2F2FF" callback={commonUpdate}/>
                                  </div> 
                              }
                              // else if(x === "headerHeight" && app.getDevice() && widgetType === "headerAi"){ 
                              //     return <div className='itemContainer d-grid'>
                              //         <label className="label">{langSettings.headerHeight}</label>
                              //         <Nouislider range={{ min: 0, max: 10 }} step="0.1" start={value} connect={"lower"} id={x} connectColor="#3899ED" handleColor="#E2F2FF" callback={commonUpdate}/>
                              //     </div>  
                              // } 
                              return null
                            })

                            item = item.filter(item => item !== null); 

                            if(item.length > 0){ 
                              return (
                                <div data-type={v.type} class={`accordion-item pannel-${widgetType} pannel-${app.getDevice()?'desktop':'mobile'} ${openId === v.type ? 'show' : ''}`}>
                                  <div class="accordion-item-header" data-target={v.type} onClick={() => toggleAccordion(v.type)}><span className='arrow-right'></span>{langSettings.spacing}</div>
                                  <div class="accordion-item-body" id={v.type}>
                                    {item}
                                  </div>
                                </div>
                              );
                            }  
                          } 
                          //  && data.properties["fixedPosition"]
                          else if(v.type === "shadowType" && data.properties.fixedPosition && data.properties["dropShadow"] !== undefined && app.getDevice()){
                            return  <div data-type={v.type} class={`accordion-item pannel-${widgetType} pannel-${app.getDevice()?'desktop':'mobile'} ${openId === v.type ? 'show' : ''}`}>
                             <div class="accordion-item-header" data-target={v.type} onClick={() => toggleAccordion(v.type)}><span className='arrow-right'></span>{langSettings.shadow}</div>
                            <div class="accordion-item-body" id={v.type}>
                              {
                                v.item.map(function(x,y){  
                                  if(x === "dropShadow"){
                                    return <React.Fragment> 
                                      <div className="itemContainer"> 
                                        <div className="form-check form-switch d-flex m-0 px-0 py-3 pt-0 pb-0 text-capitalize align-items-center">
                                          <label className="form-check-label me-2" for="dropShadow">{langSettings.dropShadow}</label>
                                          <input type="checkbox" className="form-check-input ms-auto mt-0" id="dropShadow" name="dropShadow" checked={data.properties["dropShadow"]} onChange={()=>rootUpdate("dropShadow", !data.properties["dropShadow"])}/>
                                        </div>
                                      </div>

                                      {data.properties["dropShadow"]?<React.Fragment> 
                                          <ColorWidget type={langSettings.color} id="dropShadowColor" index="98" value={data.properties["dropShadowColor"]} callback={function(a){
                                              rootUpdate("dropShadowColor", a)
                                            }}/> 

                                          <div className='itemContainer d-grid'>
                                              <label className="label">{langSettings.spread}</label>
                                              <Nouislider range={{ min: 0, max: 100 }} step="1" start={data.properties["dropShadowSpread"]} connect={"lower"} id="dropShadowSpread" connectColor="#3899ED" handleColor="#E2F2FF" callback={commonUpdate}/>
                                          </div> 

                                          <div className='itemContainer d-grid'>
                                              <label className="label">{langSettings.distance}</label>
                                              <Nouislider range={{ min: 0, max: 50 }} step="1" start={data.properties["dropShadowDistance"]} connect={"lower"} id="dropShadowDistance" connectColor="#3899ED" handleColor="#E2F2FF" callback={commonUpdate}/>
                                          </div> 

                                          <div className='itemContainer d-grid'>
                                              <label className="label">{langSettings.blur}</label>
                                              <Nouislider range={{ min: 0, max: 200 }} step="1" start={data.properties["dropShadowBlur"]} connect={"lower"} id="dropShadowBlur" connectColor="#3899ED" handleColor="#E2F2FF" callback={commonUpdate}/>
                                          </div> 
                                  </React.Fragment>:null} 
                                  </React.Fragment> 
                                  } 
                                }) 
                              }
                            </div>
                          </div> 
                          } 
                          //&& app.getDevice()
                          else if(v.type === "logoType"){
                            return (
                            <div data-type={v.type} class={`container-row  pannel-${widgetType} pannel-${app.getDevice()?'desktop':'mobile'}`} id={v.type}>
                                  {
                                    v.item.map(function(x,y){  
                                      if(x === "logo") {
                                        let showLogo = true;
                                        let disabledLogo = app.getDevice()?data.properties.showTitleWeb:data.properties.showTitle;
                                        if(data.properties.showLogo !== undefined) {
                                          showLogo = app.getDevice()?data.properties.showLogoWeb:data.properties.showLogo;
                                        }
                                        let logoPath = `${app.config().bucket72}/media/user_space/${localStorage.getItem("aiAppId")}/appicon/${localStorage.getItem("custom_app_icon_image")}`;
                                        if(localStorage.getItem("custom_app_icon_image") === "1351667928.png") {
                                          logoPath = `${app.config().reseller}/media/appicon/1351667928.png`
                                        }

                                        let nextLogoPath = data.properties.src;
                                        if(nextLogoPath.indexOf("/1351667928.png") !== -1) {
                                          nextLogoPath = `${app.config().reseller}/media/appicon/1351667928.png`;
                                        }
                                        
                                        
                                        return <div className="itemContainer">
                                          <div className="form-check form-switch d-flex m-0 p-0 pt-3 align-items-center pb-3">
                                            <label className="form-check-label label m-0" for="typelogo">{langSettings.logoImage}</label>
                                            <input type="checkbox" className="form-check-input ms-auto mt-0" id="typelogo" name="typelogo" disabled={disabledLogo?false:true} checked={showLogo} onChange={app.getDevice()?(e)=>commonUpdate("showLogoWeb", !data.properties.showLogoWeb):(e)=>commonUpdate("showLogo", !data.properties.showLogo)}/>
                                          </div>
                                          <input type="button" id="icon" value={nextLogoPath} style={{ display: "none" }} />
                                          {/* <button className={`btn btn-outline-secondary btn-image-select img-view`} style={{backgroundImage: `url('${data.properties.src}')` }} 
                                          // onClick={function(){
                                          //   app.imagePopup(data.properties.src, function(key, value){
                                          //     commonUpdate(key, value) 
                                          //   })
                                          // }}
                                          ></button>  */}

                                          <div className="upload-logo-wrap">
                                           
                                            <label for="uploadLogo" className={`btn btn-outline-secondary btn-image-select img-view`} style={{overflow:"hidden", width:"auto", display:"inline-block"}}>
                                            <img src={nextLogoPath} style={{height:"60px"}} alt="" />
                                            </label> 

                                            <input id="uploadLogo" type="file" accept="image/png, image/jpeg" width='1024' height='1024' onChange={function(event){
                                              if(!app.allowOnlyImages(event.currentTarget.files[0])) {
                                                alert(app.getLang("onlyAllowedFormats"));
                                                event.currentTarget.value = "";
                                              }
                                              else {
                                                app.uploadLogo(event, "logo", function(key, value){
                                                  window.logoUpdate(value)
                                                  //commonUpdate(key, value) 
                                                })
                                              }
                                            }}  />
                                          </div>

                                          <div className={`form-check form-switch d-flex m-0 p-0 pt-3 align-items-center pb-3`}>
                                            <label className="form-check-label label m-0" for="typelogo">{langSettings.faviconImage}</label>
                                          </div>

                                          <div className={`upload-logo-wrap`}>
                                            <label for="uploadFavicon" className={`btn btn-outline-secondary btn-image-select img-view`} style={{backgroundImage: `url('${logoPath}')` }}></label> 

                                            <input id="uploadFavicon" type="file" accept="image/png, image/jpeg" width='1024' height='1024' onChange={function(event){
                                              if(!app.allowOnlyImages(event.currentTarget.files[0])) {
                                                alert(app.getLang("onlyAllowedFormats"));
                                                event.currentTarget.value = "";
                                              }
                                              else {
                                                app.uploadLogo(event, "favicon", function(key, value){
                                                  logoPath = `${app.config().bucket72}/media/user_space/${localStorage.getItem("aiAppId")}/appicon/${localStorage.getItem("custom_app_icon_image")}`;
                                                  if(localStorage.getItem("custom_app_icon_image") === "1351667928.png") {
                                                    logoPath = `${app.config().reseller}/media/appicon/1351667928.png`
                                                  }
                                                  document.querySelector("[for='uploadFavicon']").style.backgroundImage = `url('${logoPath}')`;
                                                  //window.logoUpdate(value)
                                                  //commonUpdate(key, value) 
                                                })
                                              }
                                            }}  />
                                          </div>
                                          <p className="label d-none"><b>Note:</b> The maximum image upload size recommended is 1024X1024</p>
                                          
                                      </div> 
                                      }  
                                      //&& app.getDevice()
                                      else if(x === "logoTitle" ) {
                                        let disabledTitle = false;
                                        if(data.properties.showLogo !== undefined) {
                                          disabledTitle = app.getDevice()?data.properties.showLogoWeb:data.properties.showLogo;
                                        }
                                        return <div className="itemContainer">
                                          <div className="form-check form-switch d-flex m-0 px-0 py-0 border-0 align-items-center pb-2">
                                          <label className="form-check-label label m-0" for="logoTitle">{langSettings.siteTitle}</label>
                                          <input type="checkbox" className="form-check-input ms-auto mt-0" id="logoTitle" name="typelogo" disabled={disabledTitle?false:true} checked={app.getDevice()?data.properties.showTitleWeb:data.properties.showTitle} onChange={app.getDevice()?(e)=>commonUpdate("showTitleWeb", !data.properties.showTitleWeb):(e)=>commonUpdate("showTitle", !data.properties.showTitle)}/>
                                        </div>  
                                        
                                        <input type="text" className="logoTitle" maxlength="120" placeholder={langSettings.yourSiteTitle} defaultValue={data.text} onInput={function(e){
                                          textUpdate("text", e.target.value)
                                        }}/></div>
                                      } 
                                    }) 
                                  }
                                </div>
                            ); 
                          }
                          else if(v.type === "settingsType" && widgetType === "footerAi"){ 
                            let item = v.item.map(function(x,y){ 
                              if(x === "headerSetting" && !app.getDevice() && data.settings){
                                return <div className="form-check hide-list form-switch">
                                <label className="form-check-label label m-0 display-tool-tip tip-top" for="hideFooter">{app.getLang("hideFooter")} <span class="icon-info-circled" style={{fontSize:"13px"}}></span><span className="tooltip-text">{langSettings.infoMessageMobile}</span></label>
                                <input type="checkbox" className="form-check-input ms-auto mt-0" id="hideFooter" name="hideFooter" checked={data.settings["hideFooter"]} onChange={()=>commonUpdate("hideFooter", !data.settings["hideFooter"])}/>
                              </div>
                              }
                              if(x === "headerSetting" && app.getDevice() && data.settings){
                                return <div className="form-check hide-list form-switch">
                                <label className="form-check-label label m-0 display-tool-tip tip-top" for="hideFooterWeb">{app.getLang("hideFooter")} <span class="icon-info-circled" style={{fontSize:"13px"}}></span><span className="tooltip-text">{langSettings.infoMessageMobile}</span></label>
                                <input type="checkbox" className="form-check-input ms-auto mt-0" id="hideFooterWeb" name="hideFooterWeb" checked={data.settings["hideFooterWeb"]} onChange={()=>commonUpdate("hideFooterWeb", !data.settings["hideFooterWeb"])}/>
                              </div>
                              }
                              return null;
                            }).filter(function(v){
                              if(v === null) {
                                return false;
                              }
                              return true;
                            });

                            if(item.length > 0){
                              return (
                                <div data-type={v.type} class={`accordion-item pannel-${widgetType} pannel-${app.getDevice()?'desktop':'mobile'} ${openId === v.type ? 'show' : ''}`}>
                                  <div class="accordion-item-header" data-target={v.type} onClick={() => toggleAccordion(v.type)}><span className='arrow-right'></span>{langSettings.settings}</div>
                                  <div class="accordion-item-body" id={v.type}>
                                    {item}
                                  </div>
                                </div>
                              ); 
                            } 
                            return null;
                          }
                          else if(v.type === "settingsType" && widgetType !== "footerAi"){ 

                            let item = v.item.map(function(x,y){ 
                              let value = data["properties"][x]; 
                              if(data.viewType === "view" || data.viewType === "gridItem") {
                                value = app.getItemValue(data, x);
                              }   
                              if(x === "enableDivider" && data["properties"].enableDivider !== undefined){ 
                                 return <div className="mb-0" > 
                                  <div className='itemContainer mb-3'>
                                    <div className='form-check hide-list form-switch p-0 border-0'>
                                    <label className="label m-0">{langSettings.divider_visibility}</label>
                                    <div className="form-check form-switch ms-auto">
                                        <input data-value={value} className="form-check-input ms-auto" type="checkbox" id="enableDivider" onChange={function(a){
                                           rootUpdate("enableDivider", !value)
                                        }} checked={value} /> 
                                      </div>   
                                  </div> 
                                  </div> 

                                  {value === true?
                                      <> 
                                            <ColorWidget type={langSettings.divider_color} id="dividerColor" index={i} value={data.properties["dividerColor"]} callback={function(a){
                                                rootUpdate("dividerColor", a);
                                            }}/>

                                            <div className='itemContainer'>
                                                <label className="label">{langSettings.divider_type}</label>
                                              <div className='d-flex'>
                                                <select className="form-select" defaultValue={data.properties["dividerType"]} onChange={(e)=>rootUpdate("dividerType", e.currentTarget.value)}>
                                                  {/* <option value="">Default</option>  */}
                                                  <option value="line">{app.getLang("line")}</option>
                                                  <option value="dash">{app.getLang("dash")}</option>
                                                </select> 
                                              </div>   
                                            </div> 

                                            <div className='itemContainer d-grid mb-3'>
                                                <label className="label">{langSettings.divider_size}</label>
                                                <div className='d-flex'> 
                                                <Nouislider range={{ min: 0, max: 10 }} step="1" start={data.properties["dividerSize"]} connect={"lower"} id={"dividerSize"} connectColor="#3899ED" handleColor="#E2F2FF" callback={rootUpdate}/>
                                                  {/* <input type="number" inputMode="numeric" pattern="[0-9]*" className="form-control" min="0" max="10" value={data.properties["borderSize"]} onChange={(e)=>sizeUpdate("borderSize", e.currentTarget.value)}  onBlur={(e)=>sizeUpdateEmptyInput("borderSize", e.currentTarget.value)} style={{marginRight: "20px", width: "60px"}}/>  */}
                                                </div>   
                                              </div>  
                                      </>
                                  :null}
                     
                                  </div> 
                              }
                              else if(x === "isMap" && widgetType === "map_one") { 
                                const tempValue = data.elements["maps"]["items"][0]["summary"]["properties"]["isMap"];
                                return <div className='form-check hide-list form-switch border-bottom-0'>
                                    <label className="form-check-label label m-0">{langSettings.map}</label>
                                      <input data-value={tempValue} className="form-check-input ms-auto mt-0" type="checkbox" id="Maps" onChange={function(a){
                                         rootUpdate("isMap", !tempValue)
                                      }} checked={tempValue} /> 
                                  </div>  
                              }
                              else if(x === "FlipSwiperGrid") {  
                                return <GridWidget data={data} commonUpdate={gridUpdate} />   
                              }
                              else if(x === "autoPlay" && value !== undefined && data.properties.type === "custom") {  
                                return <div className="form-check hide-list form-switch">
                                 <label className="form-check-label label m-0 display-tool-tip tip-left">{langSettings.autoplay} <span class="icon-info-circled" style={{fontSize:"13px"}}></span><span className="tooltip-text">{langSettings.infoMessage}</span></label>
                                 <input data-value={value} className="form-check-input ms-auto mt-0" type="checkbox" id="autoPlay" onChange={function(a){
                                      rootUpdate("autoPlay", !value)
                                   }} checked={value} />  
                                </div> 
                              } 
                    
                              else if(x === "loop" && value !== undefined && data.properties.type === "custom" && data.properties.autoPlay) {  
                                return <div className="form-check hide-list form-switch">
                                    <label className="form-check-label label m-0 display-tool-tip tip-left">{langSettings.loop} <span class="icon-info-circled" style={{fontSize:"13px"}}></span><span className="tooltip-text">{langSettings.infoMessage}</span></label>
                                       <input data-value={value} className="form-check-input ms-auto mt-0" type="checkbox" id="loop" onChange={function(a){
                                         rootUpdate("loop", !value)
                                      }} checked={value} /> 
                                    </div>   
                              }  
                              else if(x === "headerSetting" && app.getDevice() && data.settings){
                                return <React.Fragment>  
                                    <div className="form-check hide-list form-switch">
                                      <label className="form-check-label label m-0 display-tool-tip tip-top" for="hideHeaderWeb">{langSettings.hideHeader} <span class="icon-info-circled" style={{fontSize:"13px"}}></span><span className="tooltip-text">{langSettings.infoMessageMobile}</span></label>
                                      <input type="checkbox" className="form-check-input ms-auto mt-0" id="hideHeaderWeb" name="hideHeaderWeb" checked={data.settings["hideHeaderWeb"]} onChange={()=>commonUpdate("hideHeaderWeb", !data.settings["hideHeaderWeb"])}/>
                                    </div>
                                     </React.Fragment> 

                              }
                              else if(x === "headerSetting" && !app.getDevice() && data.settings){
                                return <React.Fragment>  
                                    <div className="form-check hide-list form-switch">
                                      {/* <label className="form-check-label label m-0" for="hideHeader">{langSettings.hideHeader}</label> */}
                                      <label className="form-check-label label m-0 display-tool-tip tip-top" for="hideHeader">{langSettings.hideHeader} <span class="icon-info-circled" style={{fontSize:"13px"}}></span><span className="tooltip-text">{langSettings.infoMessageMobile}</span></label>
                                      <input type="checkbox" className="form-check-input ms-auto mt-0" id="hideHeader" name="hideHeader" checked={data.settings["hideHeader"]} onChange={()=>commonUpdate("hideHeader", !data.settings["hideHeader"])}/>
                                    </div>

                                    <div className="form-check hide-list form-switch">
                                    <label className="form-check-label label m-0 display-tool-tip tip-top" for="isSearch">{langSettings.searchOption} <span class="icon-info-circled" style={{fontSize:"13px"}}></span><span className="tooltip-text">{langSettings.infoMessageMobile}</span></label>
                                       
                                      <input type="checkbox" className="form-check-input ms-auto mt-0" id="isSearch" name="isSearch" checked={data.settings["isSearch"]} onChange={()=>commonUpdate("isSearch", !data.settings["isSearch"])}/>
                                    </div> 

                                    {/* Remove Notification as per Sumit and tester */}
                                    {/* <div className="form-check hide-list form-switch"> 
                                      <label className="form-check-label label m-0 display-tool-tip tip-top" for="isNotification">{langSettings.notification} <span class="icon-info-circled" style={{fontSize:"13px"}}></span><span className="tooltip-text">{langSettings.infoMessageMobile}</span></label> 
                                      <input type="checkbox" className="form-check-input ms-auto mt-0" id="isNotification" name="isNotification" checked={data.settings["isNotification"]} onChange={()=>commonUpdate("isNotification", !data.settings["isNotification"])}/>
                                    </div>  */}
                                  
                                  {data.properties.backgroundType === "pattern" || data.properties.backgroundType === "image" || data.properties.backgroundType === "custom"?<React.Fragment>
                                     <div className="form-check hide-list form-switch">
                                     <label className="form-check-label label m-0 display-tool-tip tip-top" for="isText">{langSettings.headerText} <span class="icon-info-circled" style={{fontSize:"13px"}}></span><span className="tooltip-text">{langSettings.infoMessageMobile}</span></label>
                                      <input type="checkbox" className="form-check-input ms-auto mt-0" id="isText" name="isText" checked={data.settings["isText"]} onChange={()=>commonUpdate("isText", !data.settings["isText"])}/>
                                    </div> 
                      
                                    <div className="form-check hide-list form-switch">
                                      <label className="form-check-label label m-0 display-tool-tip tip-top" for="isBlurImage">{langSettings.blurImage} <span class="icon-info-circled" style={{fontSize:"13px"}}></span><span className="tooltip-text">{langSettings.infoMessageMobile}</span></label> 
                                      <input type="checkbox" className="form-check-input ms-auto mt-0" id="isBlurImage" name="isBlurImage" checked={data.settings["isBlurImage"]} onChange={()=>commonUpdate("isBlurImage", !data.settings["isBlurImage"])}/>
                                    </div> 
                     
                                    <div className="form-check hide-list form-switch">
                                      <label className="form-check-label label m-0 display-tool-tip tip-top w-75" for="isImageInnerPage">{langSettings.headerImageInner} <span class="icon-info-circled" style={{fontSize:"13px"}}></span><span className="tooltip-text">{langSettings.infoMessageMobile}</span></label> 
                                      <input type="checkbox" className="form-check-input ms-auto mt-0" id="isImageInnerPage" name="isImageInnerPage" checked={data.settings["isImageInnerPage"]} onChange={()=>commonUpdate("isImageInnerPage", !data.settings["isImageInnerPage"])}/>
                                    </div> 
                                  </React.Fragment>:null}
                    
                              </React.Fragment> 
                              }
                              return null;
                            }) 

                            item = item.filter(item => item !== null); 
                             
                            if(item.length > 0){
                              return (
                                <div data-type={v.type} class={`accordion-item pannel-${widgetType} pannel-${app.getDevice()?'desktop':'mobile'} ${openId === v.type ? 'show' : ''}`}>
                                  <div class="accordion-item-header" data-target={v.type} onClick={() => toggleAccordion(v.type)}><span className='arrow-right'></span>{langSettings.settings}</div>
                                  <div class="accordion-item-body" id={v.type}>
                                    {item}
                                  </div>
                                </div>
                              ); 
                            } 
                          }  
                        return null;
                    })}
                </div>
            ));
    };


    let headerLayout = ""
    if(data.widgetType === "headerAi" && data.properties.headerLayout){
      headerLayout =  <>
      <SwiperHeader data={data.properties.headerLayout} id="headerLayout" className="m-3" slidesPerView="auto" spaceBetween="4" callback={(data)=>rootUpdate("headerLayout", data.toString())}/>
      <div className='container-row'>
      <div className="col-12 pb-0" > 
          <div className="form-check hide-list form-switch">
            <label className="form-check-label m-0" for="fixedPosition">{langSettings.fixedPosition}</label>
            <input type="checkbox" className="form-check-input ms-auto mt-0" id="fixedPosition" name="fixedPosition" checked={data.properties["fixedPosition"]} onChange={()=>rootUpdate("fixedPosition", !data.properties["fixedPosition"])}/>
          </div>
        </div> 

        {data.properties["fixedPosition"]?
        <div className="form-check hide-list form-switch">
            <label className="form-check-label m-0" for="fixedHeaderStyle">{langSettings.fixedHeaderStyle}</label>
            <div className="text-right ms-auto">
              <select className="form-select p-0 border-0 text-end" value={data.properties.fixedHeaderStyle} id="fixedHeaderStyle" data-index={index} data-type="fixedHeaderStyle" onChange={(event)=>rootUpdate("fixedHeaderStyle", event.target.value)}>
                {
                  [{ key: "basic", text: app.getLang("basic")}, { key: "scroll_back", text:app.getLang("scrollBack")}].map(function (v) {
                    return <option value={v.key}>{v.text}</option>
                  })
                }
              </select>
            </div> 
          </div>:null}
          </div>
      </>
    }

    let footerLayout = ""
    if(data.widgetType === "footerAi" && data.properties.footerLayout){
      footerLayout =  <>
      <SwiperHeader data={data.properties.footerLayout} id="footerLayout" className="m-3" slidesPerView="auto" spaceBetween="4" callback={(data)=>rootUpdate("footerLayout", data.toString())}/>
      </>
    }

    //console.log("data---", props.edit, data)
    let applyButton = "";
    if(props.edit.gridId) {

      applyButton = <div className="apply-box form-check hide-list justify-content-between align-items-center p-3" data-size={rootData[index].elements[props.edit.gridId].items.length}>
    <label className="form-check-label m-0">{app.getLang("apply_changes_to_all")}</label>
                                    <button type="button" className="btn btn-primary" data-id={props.edit.id} onClick={applyAll}>{app.getLang("save")}</button>

                                    </div>
      
    }
    

    
    return (
      
        <div className='tabComponent'>
          {app.getDevice()?headerLayout:null}
          {data.viewType === "navigation" && app.getDevice()?<NavForm data={data} edit={props.edit} index={index} layoutUpdate={layoutUpdate} callback={commonUpdate}/>:null}
          {/* {app.getDevice()?footerLayout:null} */}
          {footerLayout}
          {properties.length>1?
            <div className="header-nav">
                {properties.map((a, index) => (
                    <a
                        key={index}
                        className={`tab-header ${activeTab === a.tabType ? 'active' : ''}`}
                        data-id={a.tabType}
                        onClick={() => handleTabClick(a.tabType)}
                    >
                      {app.getLang(a.tabType)}
                        
                    </a>
                ))}
            </div>
          :null}

            <div className="tabComponent-content h-100">
                 
                {renderContent(activeTab)}
                {applyButton}
            </div>
        </div>
    );
};
